import { array, record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useFetchCatalogFields } from '../../catalogFieldTypes/hooks';
import { FieldOption } from '../../queryBuilder/legacyQueryBuilder/types';

export type CatalogPreviewFields = Record<string, string | undefined>;

const mapFieldOptions = (data: FieldOption[]) =>
  pipe(
    data,
    array.map(({ value, type }) => [value, type] as [string, string | undefined]),
    record.fromEntries,
  );

export const useCatalogPreviewFieldMappings = (catalogName = '') => {
  const { data, ...response } = useFetchCatalogFields(catalogName);

  return {
    data: mapFieldOptions(data),
    ...response,
  };
};
